import React, { useEffect, useState } from "react";
import axios from "axios";
import Loader from "../components/Loader";
import Title from "../components/Title";
import { useDispatch, useSelector } from "react-redux";
import { getToken } from "../slice/tokenSlice";
import { FaFilter, FaLink, FaTimes } from "react-icons/fa";

const Settlements = () => {
  const dispatch = useDispatch();
  const { url, user } = useSelector((state) => state.user);
  const [data1, setData1] = useState([]);
  const [data2, setData2] = useState([]);
  const [loading, setLoading] = useState(false);
  const getSettlements = async () => {
    try {
      const token = await dispatch(getToken());
      setLoading(true);
      const res = await axios.get(
        `${url}/proxy?url=https://www.zohoapis.in/crm/v2/Leads/${user.id}/Bills`,
        {
          headers: {
            Authorization: `Zoho-oauthtoken ${token.payload}`,
          },
        }
      );
      if (res.status === 200) {
        const data = res.data.data;
        data.forEach((item) => {
          Object.keys(item).forEach((key) => {
            item[key] = item[key] ?? "";
            if (key === "Status") {
              if (item[key] === "") {
                item.pillStatus = "";
              } else if (item[key].toLowerCase() === "paid") {
                item.pillStatus = "paid-pill";
              } else if (item[key].toLowerCase() === "pending") {
                item.pillStatus = "pending-pill";
              }
            }
          });
        });
        //
        console.log(data);
        setData1(data);
        setData2(data);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    if (user !== null) {
      getSettlements();
    }
  }, [user]);
  //
  const [searchInput, setSearchInput] = useState("");
  const [modalVisible, setModalVisible] = useState(false);
  const openModal = () => {
    setModalVisible(true);
  };
  const closeModal = () => {
    setModalVisible(false);
  };
  const [filterInputs, setFilterInputs] = useState({
    status: "",
    paymentDate: "",
  });
  const handleFilterInputs = (e) => {
    const { name, value } = e.target;
    setFilterInputs({
      ...filterInputs,
      [name]: value,
    });
  };
  const filterData = () => {
    const filtered = data1.filter((item) => {
      const nameMatch = item?.Name?.toString()
        .toLowerCase()
        .includes(searchInput.toLowerCase());

      const statusMatch =
        filterInputs.status === "" ||
        item?.Status?.toLowerCase() === filterInputs.status.toLowerCase();

      const paymentDateMatch =
        filterInputs.paymentDate === "" ||
        item?.Paid_Date?.toLowerCase() === filterInputs.paymentDate;

      return nameMatch && paymentDateMatch && statusMatch;
    });
    setData2(filtered);
    setModalVisible(false);
  };
  const resetSearchFilter = () => {
    setSearchInput("");
    setFilterInputs({
      status: "",
      paymentDate: "",
    });
    setModalVisible(false);
    setData2(data1);
  };
  useEffect(() => {
    filterData();
  }, [searchInput, data1]);
  return (
    <>
      <div className="payments-container">
        <div className="d-flex justify-content-between gap-2 flex-sm-row flex-column">
          <Title title="Activity" />
          <div className="filter-flex">
            <input
              type="text"
              className="input"
              placeholder="Search..."
              value={searchInput}
              onChange={(e) => setSearchInput(e.target.value)}
            />
            <button className="button" onClick={openModal}>
              <FaFilter />
            </button>
          </div>
        </div>
        <hr />
        <div className="project-table-overflow">
          {loading === true ? (
            <Loader />
          ) : (
            <>
              {data2.length === 0 ? (
                <p className="text-center">No data found</p>
              ) : (
                <table className="project-table settlemenmt-table">
                  <thead>
                    <tr>
                      <th>Sr</th>
                      <th>Bill number</th>
                      <th>Creditor's Name</th>
                      <th>Loan Account Number</th>
                      <th>Paid Date</th>
                      <th>Status</th>
                      <th>Payment Mode</th>
                      <th>Balance</th>
                      <th>Type of Credit</th>
                      <th>Bill Date</th>
                      <th>Due Date</th>
                    </tr>
                  </thead>
                  <tbody>
                    {data2.map((item, index) => {
                      return (
                        <tr key={index}>
                          <td>{index + 1}</td>
                          <td>{item.Name || "-"}</td>
                          <td>{item.Creditor_s_Name?.name || "-"}</td>
                          <td>{item.Loan_Account_Number || "-"}</td>
                          <td>
                            {item.Paid_Date?.split("-").reverse().join("-") ||
                              "-"}
                          </td>
                          <td>
                            <span className={`pill ${item.pillStatus}`}>
                              {item.Status || ""}
                            </span>
                          </td>
                          <td>{item.Payment_Mode || "-"}</td>
                          <td>
                            {parseFloat(item.Balance).toLocaleString() || "-"}
                          </td>
                          <td>{item.Type_of_Credit || "-"}</td>
                          <td>
                            {item.Bill_Date?.split("-").reverse().join("-") ||
                              "-"}
                          </td>
                          <td>
                            {item.Due_Date?.split("-").reverse().join("-") ||
                              "-"}
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              )}
            </>
          )}
        </div>
      </div>

      <div
        className={`modal-background ${modalVisible ? "active" : ""}`}
        style={{ zIndex: "100" }}
      >
        <div className="modal-container">
          <div className="d-flex align-items-end justify-content-between">
            <h2>Filter</h2>
            <button className="red-button" onClick={closeModal}>
              <FaTimes />
            </button>
          </div>
          {/*  */}
          <hr />
          <div>
            <div className="mt-4">
              <p className="mb-2">Payment status</p>
              <select
                className="input"
                name="status"
                value={filterInputs.status}
                onChange={handleFilterInputs}
              >
                <option value="">select</option>
                <option value="paid">paid</option>
                <option value="unpaid">unpaid</option>
              </select>
            </div>
            <div className="mt-4">
              <p className="mb-2">Payment date</p>
              <input
                type="date"
                className="input"
                name="paymentDate"
                value={filterInputs.paymentDate}
                onChange={handleFilterInputs}
              />
            </div>
          </div>
          <div className="d-flex align-content-center justify-content-end gap-2 mt-4">
            <button
              className="red-button"
              onClick={resetSearchFilter}
              style={{ width: "90px" }}
            >
              Reset
            </button>
            <button
              className="button"
              onClick={filterData}
              style={{ width: "90px" }}
            >
              Apply
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default Settlements;
